import { useEffect, useState } from "react";
import axiosConfig from "../../../axiosConfig";
import BoxAlert from "../../LoginComponent/BoxAlert";
import Loading from "../../LoadingComponent";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const VerifySuccess = (props) => {
    const { t } = useTranslation();
    const [completed, setCompleted] = useState(false);
    const [inComplete, setInComplete] = useState(false);
    const [loading, setLoading] = useState(true);
    const [email, setEmail] = useState("");
    const params = useParams();

    useEffect(() => {
        axiosConfig.get(`/api/user/verify-account/${params.verifyCode}`).then((response) => {
            setLoading(false);
            if (response.data.status === 200) {
                setCompleted(true);
                setEmail(response.data.email);
            } else {
                setInComplete(true);
            }
        });
    }, []);

    return (
        <section className="register-page">
            {loading && <Loading />}
            {completed && (
                <BoxAlert title={t("verify_success")} paragraph={`${t("profile_email")}: <strong>${email}</strong>`} />
            )}
            {inComplete && <BoxAlert title={t("verify_unsuccess")} type="error" />}
        </section>
    );
};

export default VerifySuccess;
